
<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs />
        <div class="table-agile-info">
          <!--查询条件-->
          <div class="common-new-title mode2">
            <span>AI 文本配置管理</span>
            <a class="icon-index-1 jm-fr" @click="creatPrompt">
              <el-button
                type="primary"
                size="medium">创建新场景</el-button>
            </a>
          </div>
          <el-row :gutter="12" v-loading="loading">
            <el-col :span="6" v-for="item in listData" :key="item.id">
              <el-card class="prompt" shadow="hover" body-style="padding-bottom: 10px">
                <h3>{{ item.title }}</h3>
                <div class="content">
                  {{ item.intro }}
                </div>
                <div class="bottom clearfix">
                  <span class="time">{{ item.create_time }}</span>
                  <span class="button">
                    <el-button type="text" @click="editPrompt(item)">编辑</el-button>
                    <el-button type="text" @click="dropPrompt(item)">删除</el-button>
                  </span>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <el-dialog width="600px" :title="!formData.id ? '创建新场景' : '修改场景设置'" :visible.sync="dialogVisible">
      <el-form :model="formData" v-loading="loading" ref="formData" label-width="100px">
        <el-form-item label="场景名称" prop="title" :rules="[
          { required: true, message: '名称不能为空' },
          { min: 3, max: 16, message: '长度在 3-16 个字符' }
        ]">
          <el-input
            type="text"
            v-model="formData.title"
            class="jm-input400"
            placeholder="功能名称"
            clearable />
        </el-form-item>
        <el-form-item label="功能描述" prop="intro" :rules="[
          { required: true, message: '功能描述不能为空' },
          { max: 50, message: '最多 50 个字符' }
        ]">
          <el-input
            type="textarea"
            v-model="formData.intro"
            class="jm-input400"
            placeholder="对该场景的描述信息"
            clearable />
        </el-form-item>
        <el-form-item label="提示词" prop="prompt" :rules="[
          { required: true, message: '提示词不能为空' },
        ]">
          <el-input
            type="textarea"
            :rows="8"
            v-model="formData.prompt"
            class="jm-input400"
            placeholder="请填写提示词"
            clearable />
          <p class="tips">
            场景与提示词说明请<a href="https://open.bigmodel.cn/dev/openpower" target="_blank">参考这里</a>
          </p>
        </el-form-item>
        <el-form-item label="排序" prop="sort_num">
          <el-input
            type="number"
            class="jm-input135"
            v-model="formData.sort_num"
            clearable />
          <span class="tips">数字越大越靠前</span>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog" :disabled="loading">取 消</el-button>
        <el-button type="primary" @click="savePrompt" :disabled="loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';

export default {
  data() {
    return {
      loading: false,
      refresh: false,
      dialogVisible: false,
      formData: {
        id: 0,
        title: '',
        intro: '',
        prompt: '',
        sort_num: 0,
        // 微调参数，暂时不用
        top_p: 0.7,
        temperature: 0.95,
      },
      listData: []
    };
  },
  mounted() {
    this.listPrompt();
  },
  methods: {
    creatPrompt() {
      this.formData = {
        id: 0,
        title: '',
        intro: '',
        prompt: '',
        sort_num: 0,
        // 微调参数，暂时不用
        top_p: 0.7,
        temperature: 0.95,
      };
      this.dialogVisible = true;
    },
    editPrompt(rowData) {
      this.dialogVisible = true;
      this.formData = rowData;
    },
    dropPrompt(rowData) {
      this.$confirm(`确定要删除场景“${rowData.title}”?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$http._post({
          url: '/index/smart_chat/dropPrompt',
          data: { id: rowData.id }
        }).then((res) => {
          this.loading = false;
          if (res.result === 0) {
            this.$message.success(res.msg);
            this.refresh = true;
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    savePrompt() {
      let formData = this.formData;
      this.loading = true;
      this.$http._post({
        url: '/index/smart_chat/savePrompt',
        data: formData
      }).then((res) => {
        this.loading = false;
        if (res.result === 0) {
          this.$message.success(res.msg);
          this.refresh = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    listPrompt() {
      this.loading = true;
      this.$http._get({
        url: '/index/smart_chat/listPrompt',
      }).then((res) => {
        this.loading = false;
        this.refresh = false;
        this.listData = Object.assign({}, res.data);
        if (res.result !== 0) {
          this.$message.error(res.msg);
        }
      });
    }
  },
  watch: {
    refresh(value) {
      if (value) {
        this.closeDialog();
        this.listPrompt();
      }
    }
  },
  components: {
    'jm-crumbs': crumbs,
  }
};
</script>
<style scoped>

.prompt {
  margin-bottom: 18px;
  padding-bottom: 0;
}
.prompt h3{
  line-height: 200%;
  padding-bottom: 5px;
}
.prompt .content{
  color: #888;
  padding-bottom: 5px;
  height: 38px;
  overflow: hidden;
}
.prompt .bottom {
  font-size: 13px;
  margin-top: 13px;
}
.prompt .time {
  display: inline-block;
  height: 40px;
  box-sizing: border-box;
  line-height: 40px;
  color: #999;
}
.prompt .button {
  padding: 0;
  float: right;
}
.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}
.clearfix:after {
    clear: both
}
.tips {
  color: #999
}
span.tips {
  margin-left: 10px;
}
.tips a {
  color: rgb(74, 74, 201);
}
</style>

